export enum SourceSystem {
  Sage = 'JAPAC X3',
  Global = 'eBS'
}
